export enum ToastTypeEnum {
  INFO = 'info',
  ERROR = 'error',
  SECURE = 'secure',
  SUCCESS = 'success',
  WARNING = 'warning'
}
